import React from 'react';
import { cn } from '../../utils/cn';

const Skeleton = ({ className = '', ...props }) => {
  return (
    <div
      className={cn(
        'animate-pulse rounded-lg bg-gray-200',
        className
      )}
      {...props}
    />
  );
};

const SkeletonText = ({ lines = 3, className = '' }) => {
  return (
    <div className={cn('space-y-3', className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton 
          key={i} 
          className={cn(
            'h-4',
            i === lines - 1 && 'w-3/4'
          )}
        />
      ))}
    </div>
  );
};

const SkeletonCard = ({ className = '' }) => {
  return (
    <div className={cn('bg-white rounded-xl p-6 space-y-4', className)}>
      <Skeleton className="h-48 w-full" />
      <Skeleton className="h-6 w-3/4" />
      <SkeletonText lines={2} />
    </div>
  );
};

Skeleton.Text = SkeletonText;
Skeleton.Card = SkeletonCard;

export default Skeleton;

